import { assertUnreachable } from '@sgme/fp';
import { ConnectedCpOrderSidePanel } from 'components/secondaryMarket/cpOrder/sidePanel';
import { DlpOrderForm } from 'components/secondaryMarket/dlpOrder/dlpOrderForm';
import { DlpOrderFormContent } from 'components/secondaryMarket/dlpOrder/dlpOrderFormContent';
import { ConnectedDlpOrderSidePanel } from 'components/secondaryMarket/dlpOrder/sidePanel';
import { ConnectedLimitOrderSidePanel } from 'components/secondaryMarket/limitOrder/sidePanel/sidePanel.connect';
import { ConnectedSidePanel } from 'components/secondaryMarket/live/sidePanel';
import { ConnectedQuoteRealtimeForm } from 'components/secondaryMarket/quoteRealtime';
import { ConnectedLimitOrderForm } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/limitOrder/LimitOrder.connect';
import { LimitOrderFormContent } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/limitOrder/LimitOrderFormContent';
import { ConnectedLiveForm } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/liveForm/liveForm.connect';
import { LiveFormContent } from 'components/Workspaces/SecondaryMarketQuotes/Tabs/liveForm/LiveFormContent';
import { FC } from 'react';
import type { SecondaryMarketQuotesTabType } from 'state/workspaces/model';

import { ConnectedCpOrderForm, ConnectedCpOrderFormContent } from './cpOrder';

type SecondaryMarketQuoteTabProps = { tabId: string; tabType: SecondaryMarketQuotesTabType };
export const SecondaryMarketQuoteTab: FC<SecondaryMarketQuoteTabProps> = ({ tabId, tabType }) => {
  switch (tabType) {
    case 'realtimeQuote':
      return <ConnectedQuoteRealtimeForm tabId={tabId} />;
    case 'closePriceOrder':
      return (
        <ConnectedCpOrderForm tabId={tabId} sidePanel={<ConnectedCpOrderSidePanel tabId={tabId} />}>
          <ConnectedCpOrderFormContent tabId={tabId} workspaceType="secondaryMarketQuotes" isModification={false} />
        </ConnectedCpOrderForm>
      );
    case 'live':
      return (
        <ConnectedLiveForm
          tabId={tabId}
          workspaceType="secondaryMarketQuotes"
          sidePanel={<ConnectedSidePanel tabId={tabId} />}
        >
          <LiveFormContent tabId={tabId} />
        </ConnectedLiveForm>
      );
    case 'limitOrder':
      return (
        <ConnectedLimitOrderForm
          tabId={tabId}
          workspaceType="secondaryMarketQuotes"
          sidePanel={<ConnectedLimitOrderSidePanel formId={tabId} />}
        >
          <LimitOrderFormContent tabId={tabId} />
        </ConnectedLimitOrderForm>
      );
    case 'dlpProducts':
      return (
        <DlpOrderForm tabId={tabId} isLoading={false} sidePanel={<ConnectedDlpOrderSidePanel tabId={tabId} />}>
          <DlpOrderFormContent tabId={tabId} />
        </DlpOrderForm>
      );
    default:
      return assertUnreachable(tabType, 'Unhandled tab type');
  }
};
